import { Receipt } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminInvoices() {
  return (
    <CollectionAdmin
      path="invoices"
      title="Računi"
      subtitle="Izdani računi za pretplate i oglase"
      icon={Receipt}
      testid="admin-invoices"
      fields={[
        { key: 'number', label: 'Broj računa' },
        { key: 'recipient_name', label: 'Ime primatelja' },
        { key: 'recipient_email', label: 'Email primatelja' },
        { key: 'amount_eur', label: 'Iznos (EUR)', type: 'number' },
        { key: 'vat_pct', label: 'PDV (%)', type: 'number' },
        { key: 'status', label: 'Status (paid/unpaid/cancelled)' },
        { key: 'note', label: 'Bilješka', type: 'textarea' },
      ]}
    />
  );
}
